module.exports = __webpack_public_path__ + "static/media/carousel_four_medium_720x480.bfb92e22.jpg";